var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"center_status_pop",staticStyle:{"display":"none"},attrs:{"id":"pop_des"}},[_vm._v("pop_des")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }